/**
 * catalogueSlice — UI state for the catalogue step.
 *
 * Catalogue DATA lives in React Query (`useCatalogue`). This slice only holds
 * selection + scroll-anchor state so the user can navigate away and back
 * without losing their place.
 */

import type { StateCreator } from 'zustand'

import type { QuotaPreviewEntryV2DTO } from 'models/purchaseFlowRevamp'

import type { PfStoreState } from '../store'

export interface SessionQuotaPreview {
  sessionId: string
  entries: QuotaPreviewEntryV2DTO[]
}

export interface CatalogueSliceState {
  /** Active category tab id (matches `CatalogueCategory.id`). */
  activeCategoryId: string | null
  /** Fuzzy-search query entered by the user. */
  searchQuery: string
  /** Y-scroll position of the list, used for back-nav restore. */
  scrollAnchor: number
  quotaPreview: SessionQuotaPreview | null
}

export interface CatalogueSliceActions {
  setActiveCategory(categoryId: string | null): void
  setSearchQuery(q: string): void
  setScrollAnchor(y: number): void
  setQuotaPreview(preview: SessionQuotaPreview | null): void
}

export type CatalogueSlice = CatalogueSliceState & CatalogueSliceActions

export const createCatalogueSlice: StateCreator<PfStoreState, [], [], CatalogueSlice> = (set) => ({
  activeCategoryId: null,
  searchQuery: '',
  scrollAnchor: 0,
  quotaPreview: null,

  setActiveCategory: (categoryId) => set({ activeCategoryId: categoryId }),
  setSearchQuery: (q) => set({ searchQuery: q }),
  setScrollAnchor: (y) => set({ scrollAnchor: y }),
  setQuotaPreview: (preview) => set({ quotaPreview: preview }),
})
